// extracted by mini-css-extract-plugin
export default {"innerWrapper":"yv-z","tooltipWrapper":"zv-z","icon":"Av-z","tooltip":"Bv-z","content":"Cv-z"};